import { fetchPrivateApi } from '@/lib/api/apiServiceBase.ts';
import { TableDefinitionDto } from '@/components/table/types/TableDefinitionDto.ts';
import { PageRequest } from '@/components/table/types/PageRequest.ts';
import { FilterCriteriaDto } from '@/components/table/types/FilterCriteriaDto.tsx';
import { PagedDto } from '@/components/table/types/PagedDto.ts';
import { buildPageRequestParams } from '@/components/table/types/TableUtil.ts';
import { ClientDetailsDto } from '@/features/dashboard/clients/types/ClientDetailsDto.ts';
import { ClientListDto } from '@/features/dashboard/clients/types/ClientListDto.ts';
import { BookingByTourClientDto } from '@/features/dashboard/clients/types/BookingByTourClientDto.ts';

const clientsApi = {
  getTableDefinition: async (): Promise<TableDefinitionDto> => {
    return await fetchPrivateApi<TableDefinitionDto>(
      'GET',
      `clients/table-definition`,
    );
  },
  getClients: async (
    pageRequest: PageRequest,
    filterCriteria: FilterCriteriaDto,
  ): Promise<PagedDto<ClientListDto>> => {
    const params = buildPageRequestParams(pageRequest);
    return await fetchPrivateApi<PagedDto<ClientListDto>>(
      'POST',
      `clients/all?${params.toString()}`,
      filterCriteria,
    );
  },
  getClient: async (clientId: string): Promise<ClientDetailsDto> => {
    return await fetchPrivateApi<ClientDetailsDto>(
      'GET',
      `clients/${clientId}`,
    );
  },
  getBookingDetails: async (
    clientId: string,
    tourId: string,
  ): Promise<BookingByTourClientDto> => {
    return await fetchPrivateApi<BookingByTourClientDto>(
      'GET',
      `client/${clientId}/tours/${tourId}/booking-details`,
    );
  },
};

export default clientsApi;
